import { render, staticRenderFns } from "./ChampionshipNavigationNav.vue?vue&type=template&id=64414756&scoped=true&"
import script from "./ChampionshipNavigationNav.vue?vue&type=script&lang=js&"
export * from "./ChampionshipNavigationNav.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipNavigationNav.vue?vue&type=style&index=0&id=64414756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64414756",
  null
  
)

export default component.exports